module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門5_3.875a8bc3.png";